import { DatePicker } from 'antd';
import type { RangePickerProps } from 'antd/lib/date-picker';
import { type CSSProperties, useMemo } from 'react';
import styled from 'styled-components';

import { DATE_FORMAT } from '@/utils/time';

const { RangePicker } = DatePicker;

const StyledRangePicker = (
  props: RangePickerProps & {
    hideTrigger?: boolean;
  },
) => {
  const height = useMemo(() => {
    switch (props.size) {
      case 'small':
        return '24px';
      case 'middle':
        return '32px';
      case 'large':
        return '40px';
      default:
        return '24px';
    }
  }, [props.size]);

  const fontSize = useMemo(() => {
    switch (props.size) {
      case 'small':
        return '16px';
      case 'middle':
        return '20px';
      case 'large':
        return '24px';
      default:
        return '16px';
    }
  }, [props.size]);

  return (
    <Style
      style={{
        height,
        fontSize,
        borderRadius: 32,
        ...(props.hideTrigger ? hideStyle : {}),
      }}
    >
      <RangePicker
        {...props}
        format={DATE_FORMAT.readable}
        allowClear={false}
        getPopupContainer={() =>
          document.getElementById('syncly-popup-layer') as HTMLDivElement
        }
        size={props.size || 'small'}
      />
    </Style>
  );
};

const hideStyle: CSSProperties = {
  width: 0,
  border: 'none',
  opacity: 0,
  padding: 0,
  position: 'relative',
  overflow: 'hidden',
};

const Style = styled.div`
  .ant-picker {
    /* FIXME: Ant design RangePicker 의 input을 display: none 하면 작동하지 않아 opacity, position 조합으로 숨김 */
    /* 새로 만들던가, 가능한 버전을 찾던가 조치 필요 */
    height: 100%;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
  }
  .ant-picker-cell-range-hover::before,
  .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end::before,
  .ant-picker-cell-range-hover-start::before,
  .ant-picker-cell-range-hover-end::before,
  .ant-picker-cell-in-range.ant-picker-cell-range-hover-end
    .ant-picker-cell-inner::after,
  .ant-picker-cell-in-range.ant-picker-cell-range-hover-start
    .ant-picker-cell-inner::after {
    background-color: ${(props) => props.theme.colors.gray400} !important;
  }
  .ant-picker-input {
    position: absolute;
    opacity: 0;
  }
  .ant-picker-range-separator {
    display: none;
  }
  .ant-picker-active-bar {
    display: none;
  }
  .ant-picker-suffix {
    margin-inline-start: 0;
    .anticon-calendar {
      color: ${(props) => props.theme.colors.gray800};
    }
  }
`;

export default StyledRangePicker;
